<google-map [width]="'100%'" [height]="'100%'" [options]="mapOptions">
  <ng-container *ngIf="mapTrackingPoints">
    <!-- STOPS MARKERS -->
    <map-marker
      *ngFor="let stop of mapTrackingPoints.stops; let i = index"
      #stopMarkers
      [options]="mapConfig.stopMarkerOptions[i]"
      (mapClick)="stopMarkerClick(i, stop)"
    >
    </map-marker>

    <map-info-window #stopInfoWindow [options]="stopInfoWindowConfig">
      <div *ngIf="stopMarkerInfoContent$ | async as content" class="info-window">
        <p class="tw-text-bosch-xl tw-font-strong tw-mt-0 tw-mb-4">
          {{ 'monitoring.shipmentsTrackingMap.wayPointDetails' | translate }}
        </p>
        <div class="tw-flex tw-flex-col tw-mb-3">
          <span class="tw-text-bosch-s tw-mb-0.5">
            {{ 'monitoring.shipmentsTrackingMap.status' | translate }}
          </span>
          <div class="tw-flex">
            <ng-container *ngVar="content.actions as tracePointActionNames">
              <bosch-ui-chip
                *ngFor="let action of tracePointActionNames; let isFirst = first"
                [class.tw-ml-3]="!isFirst"
              >
                {{ action }}
              </bosch-ui-chip>
            </ng-container>
          </div>
        </div>
        <div class="tw-flex tw-flex-col tw-mb-3">
          <span class="tw-text-bosch-s">
            {{ 'monitoring.shipmentsTrackingMap.portId' | translate }}
          </span>
          <span class="tw-text-bosch-m">
            {{ content.name }}
          </span>
        </div>
        <div class="tw-flex tw-flex-col">
          <span class="tw-text-bosch-s">
            {{ 'common.field.address' | translate }}
          </span>
          <span class="tw-text-bosch-m">
            {{ content.address }}
          </span>
        </div>
      </div>
    </map-info-window>

    <map-polyline *ngFor="let options of mapConfig.stopPolylineOptions" [options]="options"></map-polyline>
    <!-- STOPS MARKERS -->

    <!-- POINTS MARKERS -->

    <map-polyline [options]="mapConfig.pointPolylineOptions">
      <map-marker
        *ngFor="let options of mapConfig.pointMarkerOptions; let i = index"
        [options]="options"
        (mapClick)="pointMarkerClick(i)"
        #pointMarkers
      >
      </map-marker>
    </map-polyline>

    <map-marker
      *ngIf="mapConfig.vehicleMarkerOptions as options"
      [options]="options"
      #pointMarkers
      (mapClick)="pointMarkerClick(mapConfig.pointMarkerOptions.length - 1)"
    >
    </map-marker>

    <map-info-window #pointInfoWindow [options]="pointInfoWindowConfig">
      <div *ngIf="pointMarkerInfoContent$ | async as dateTime" class="info-window info-window_point">
        <p class="tw-text-bosch-xl tw-font-strong tw-mt-0 tw-mb-4">
          {{ 'monitoring.shipmentsTrackingMap.wayPointDetails' | translate }}
        </p>
        <div class="tw-flex tw-flex-col">
          <span class="tw-text-bosch-s">
            {{ 'monitoring.shipmentsTrackingMap.dateOfCreation' | translate }}
          </span>
          <ui-date-with-profile-and-local-timezone
            class="tw-text-bosch-m"
            [timestamp]="dateTime.timestamp"
            [localTimezoneData]="dateTime.localTimezoneData"
            [profileTimezoneData]="dateTime.profileTimezoneData"
          ></ui-date-with-profile-and-local-timezone>
        </div>
      </div>
    </map-info-window>
    <!-- POINTS MARKERS -->
  </ng-container>
</google-map>
